import moment from 'moment';

import type { IClinicalQAReviewDiscourse } from '../../../../utils/types';

export const getLatestDiscourseComment = (discourses: IClinicalQAReviewDiscourse[] = []) =>
  [...discourses].sort(
    (a, b) =>
      (b.date_submitted ? moment(b.date_submitted).valueOf() : 0) -
      (a.date_submitted ? moment(a.date_submitted).valueOf() : 0),
  )[0]?.comment || 'No comment provided';
